import { RateAdapter } from "./RateAdapter";

import { PricingService } from "../../lookup/pricing/PricingService";

export class FwdTrackingAdapter extends RateAdapter {
  constructor(pricing: PricingService, dealtMode: boolean) {
    super(pricing, dealtMode);
  }

  getValue(order: any, columnProperty: string): string {
    if (this.pricingService) {
      return this.pricingService.getBlotterFwdTracking(order);
    }
    return String(order[columnProperty]);
  }

  retrieveData(order: any, columnProperty: string): string {
    let value = this.getValue(order, columnProperty);
    if (this.pricingService) {
      if (!this.dealtMode) {
        if (order.isInvertedOrderFg) {
          return (
            `<span class="blotter_amt_align_invert_left"><sup>1</sup>/<sub>n</sub></span>` +
            `<span class="blotter_amt_align_invert_center">${value}</span><span class="blotter_amt_align_invert_right"><sup>1</sup>/<sub>n</sub></span>`
          );
        }
      }
    }

    return value;
  }
}
